function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcaseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.758 328.911c35.631 4.62 76.624 7.25 120.242 7.25s84.611-2.63 120.242-7.25M457.284 312.114c29.702-9.584 47.216-21.371 47.216-34.116V167.823c0-17.709-14.356-32.065-32.065-32.065H39.565c-17.709 0-32.065 14.356-32.065 32.065v110.175c0 16.922 30.875 32.157 80.16 42.785",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#868689",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.468 300.759v131.596c0 17.709-14.356 32.065-32.065 32.065H55.597c-17.709 0-32.065-14.356-32.065-32.065V300.759",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#868689",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.726 360.21h-16.032c-8.854 0-16.032-7.178-16.032-16.032v-32.065c0-8.854 7.178-16.032 16.032-16.032h16.032c8.854 0 16.032 7.178 16.032 16.032v32.065c0 8.854-7.178 16.032-16.032 16.032zM95.677 135.758v160.323M127.742 135.758v128.258M87.661 328.145h48.097M408.306 360.21h-16.032c-8.854 0-16.032-7.178-16.032-16.032v-32.065c0-8.854 7.178-16.032 16.032-16.032h16.032c8.854 0 16.032 7.178 16.032 16.032v32.065c.001 8.854-7.177 16.032-16.032 16.032zM384.258 135.758v160.323M416.323 135.758v160.323M376.242 328.145h48.097M272.032 304.097h-32.065c-8.854 0-16.032-7.178-16.032-16.032v0c0-8.854 7.178-16.032 16.032-16.032h32.065c8.854 0 16.032 7.178 16.032 16.032v0c.001 8.854-7.177 16.032-16.032 16.032zM328.161 87.628a15.98 15.98 0 0 1-3.519-.391 314.125 314.125 0 0 0-137.284 0c-8.666 1.965-17.21-3.503-19.148-12.142-1.934-8.642 3.503-17.214 12.142-19.148a346.194 346.194 0 0 1 151.297 0c8.638 1.934 14.075 10.506 12.142 19.148-1.672 7.46-8.291 12.533-15.63 12.533zM179.267 86.883l-19.461 48.875M332.733 86.883l19.461 48.875",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#868689",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseX);
export default __webpack_public_path__ + "static/media/briefcaseX.8162107074de29ae3f6f1dd9da1d7c52.svg";
export { ForwardRef as ReactComponent };